import { FormValidator, type FormValidatorContext, type FormValidatorConfig, type FormValidatorSettings, SelectableFormElement } from '@common/index';

export type EducationElementRequiredValidatorSettings = FormValidatorSettings;

export type EducationElementRequiredValidatorConfig = FormValidatorConfig<EducationElementRequiredValidatorSettings>;

export class EducationElementRequiredValidator extends FormValidator<EducationElementRequiredValidatorSettings> {
  constructor() {
    super();
    this._name = 'educationElementRequired';
    this._settings = {
      invalidMessage: 'form.validator.educationElementRequired.invalidMessage',
      needTranslate: true
    };
  }

  public override async onValidate(value: any, context: FormValidatorContext) {
    const element = context.element.parent?.getChild('postGraduateEducationElementId') as SelectableFormElement;
    if (element?.value) {
      this._valid = !!value;
    } else {
      this._valid = !value;
    }

    if (!this._valid) {
      this.addMessage(this._settings.invalidMessage);
    }
  }
}
